import { utils } from '..';
import { Select } from '../../Feature/select';
import { Datepicker } from '../../Feature/datepicker';

// Create API Query string from object
export function createQueryString(obj) {
    let qString = '';
    // Exclude the empty filters
    const sortAppliedFilters = utils.removeEmpty(obj);
    if(Object.entries(sortAppliedFilters).length > 0) {
        qString += '?';
        Object.entries(sortAppliedFilters).forEach(([key, val], i) => {
            qString += `${key}=${val}`;
            if(i < Object.entries(sortAppliedFilters).length - 1) {
                qString += '&';
            }
        })
    }
    return qString;
}

// Create filter container
export function createFilterContainer(elem, filterElem) {
   // if filter container exist then return
   if(!filterElem) {
        // Create filter div
        const filterContainer = document.createElement('div');
        filterContainer.className = 'datatable__filters';
        // Create filter row
        const rowElement = document.createElement('div');
        rowElement.className = 'row form-group';
        // Prepend to datatable
        filterContainer.append(rowElement);
        elem.prepend(filterContainer);
        return rowElement;
    };

    return filterElem.querySelector('.form-group');
}

// Create dropdown
export function createDropDown(label, filters, filterElem, cb) {
    const
        oCol = utils.createElement('div', {
            'class': 'col-sm-12 col-md-3',
        }),
        oHtml = utils.createElement('div', {
            'class': 'form-select',
            'data-select': ''
        }, oCol),
        oSelect = utils.createElement('select', {
            'name': label,
            'innerHTML': `${filters.map(item => `<option value="${item['Key']}">${item['Value']}</option>`).join("")}`
        }, oHtml);

    // Add event listener to oSelect
    oSelect.addEventListener('change', cb);
    new Select(oHtml);

    // Append to filter element
    filterElem.append(oCol);
    return;
}

// Create Datepicker
export function createDatePicker(settings, label, queryAttr, val, filterElem, cb) {
    const generatedId = "datepicker-" + Math.floor(Math.random() * 99999)
    const wrapperElement = utils.createElement('div', {
        'class': 'col-sm-12 col-md-3 d-grid',
    });

    // Create label
    if(label) {
        const labelElement = utils.createElement('label', {
            'class': 'col-sm-12 col-md-3',
            'innerText': label,
            'for': generatedId
        });
        wrapperElement.append(labelElement);
    };
    
    // Create input
    const inputContainerElement = utils.createElement('div', {
        'class': 'input-group',
    }, wrapperElement);

    const inputElement = utils.createElement('input', {
        'id': generatedId,
        'class': 'form-control',
        'type': 'text',
        'name': queryAttr,
        'value': utils.createNewDateFormat(`{{mm}}-{{dd}}-{{yy}}`, val),
        'data-datepicker': JSON.stringify(settings),
        'autocomplete': 'off',
        // Custom datepicker function
        'data-onSelect': '',
        'data-onClose': ''
    }, inputContainerElement);

    // Create icon
    utils.createElement('i', {
        'class': 'eva eva-calendar-outline',
        'aria-hidden': 'true'
    }, inputContainerElement);

    // Append elements
    filterElem.append(wrapperElement);

    // Attach pickadate to input field
    new Datepicker(inputElement);

    // Add event listener
    inputElement.addEventListener('change', cb);
}

// toggle sorting contents asc / desc
export function toggleSorting(element, list) {
    // Remove class from other items except the selected
    let sortOrder = element.classList.contains('is-desc') ? 'asc' : 'desc';
    list.forEach(item => {
        item.classList.remove('is-asc');
        item.classList.remove('is-desc');
    })
    element.classList.add(`is-${sortOrder}`);
    return sortOrder;
}

export function checkTableElement(element) {
    // Check if table exist
    const isThisElementATable = element.tagName.toLowerCase();
    const isTableCreated = element.querySelector('table');

    if(isThisElementATable === "table") {
        // This element is table
        return element;
    }
    if(isTableCreated) {
        // Sub element is table
        return isTableCreated;
    }
    return false;
}